<template>
    <div class="lc">
        <div class="lt-left">
            <div class="bg"></div>
            <div class="bg1 rotateXZ-element imgdealy2"></div>
            <div class="bg2 rotateXZ-element"></div>
            <div class="bg3"></div>
        </div>
        <div ref="cmain1" class="cmain"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope73",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
    },
    data() {
        return {
            title: "scope15-【组件】基础圆环图样式2-完成",
            timer: null,
            defaultdata: [
                { value1: "系列一", value2: "1", value3: "单位" },
                { value1: "系列二", value2: "4" },
                { value1: "系列三", value2: "11" },
                { value1: "系列四", value2: "32" },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
                this.cDrawCircle();
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
    },
    methods: {
        ...methods,
        cDrawCircle() {
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.cmain1);
            let colorData = ["#0273D4", "#03E1E0", "#00D485", '#b4e5fa'];
            let total = 0;
            let vdata = this.defaultdata.map((item, i) => {
                let newitem = {
                    name: item.value1,
                    value: +item.value2,
                    itemStyle: { color: colorData[i] },
                };
                total += +item.value2;
                return newitem;
            });
            vdata.forEach((item) => {
                item.per = ((item.value / total) * 100).toFixed(1);
            });
            let unit = this.defaultdata[0].value3;
            var Toption = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical", //文字 行 排放 默认列
                    top: "14%",
                    right: 20,
                    itemHeight: 15, //图例的高度  文字左边那个
                    itemWidth: 15,
                    z: 5,
                    // data: vdata.map(item => item),
                    textStyle: {
                        //设置文本样式
                        color: "#CBD8DE",
                        lineHeight: 32,
                        fontWeight: "400",
                        fontSize: "14",
                        // padding: [0, 0, 0, 10],
                        rich: {
                            a: {
                                width: 40,
                                padding: [0, -20, 0, 10],
                                fontSize: 14,
                            },
                            b: {
                                padding: [0, 0, 0, 28],
                                fontSize: 14,
                                color: "#D7A651",
                            },
                            c: {
                                padding: [0, 0, 0, 0],
                                fontSize: 14,
                                color: "#D7A651",
                            },
                        },
                    }, //图例的高度
                    formatter: function (name) {
                        let newName = name.length > 3 ? name.slice(0, 3) + "..." : name;
                        let nowdata = vdata.find((item) => item.name == name);
                        let arr = [
                            "{a|" + newName + "}",
                            "{b|" + nowdata.per + "%" + "}",
                            "{c|" + nowdata.value + unit + "}",
                        ];
                        return arr.join("    ");
                    },
                },
                series: [
                    {
                        type: "pie",
                        //选中ple的中间40-50
                        center: ["24%", "50%"],
                        radius: ["50%", "65%"],
                        label: {
                            show: false,
                            position: "center",
                        },
                        itemStyle: {
                            normal: {
                                borderColor: "#000",
                                borderWidth: 2,
                                // color: this.vdata1.itemStyle
                            },
                        },
                        data: vdata.map((item) => item),
                    },
                ],
            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.cDrawCircle();
    },
};
</script>

<style scoped lang="scss">
.lc {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
    overflow: hidden;
}

.lt-left {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-110%, -50%);
    z-index: 1;
}

.lt-left .bg {
    width: 190px; //+20
    height: 190px;
    // margin: 38px 0 0 40px;
    box-sizing: border-box;
    background: url("@/assets/temimg5/piebg5.png") no-repeat;
    background-size: 100%;
    position: relative;
    z-index: 1;
}

.lt-left .bg1 {
    width: 152px; //+20
    height: 152px;
    position: absolute;
    left: calc(50% - 76px);
    top: calc(50% - 76px);
    // margin: 38px 0 0 40px;
    box-sizing: border-box;
    background: url("@/assets/temimg5/piebg.png") no-repeat;
    background-size: 100%;
    z-index: 5;
}

.lt-left .bg2 {
    width: 88px; //+20
    height: 88px;
    // margin: 38px 0 0 40px;
    position: absolute;
    left: calc(50% - 44px);
    top: calc(50% - 44px);
    box-sizing: border-box;

    background: url("@/assets/temimg5/piebg2.png") no-repeat;
    background-size: 100%;

    z-index: 10;
}

.lt-left .bg3 {
    width: 32px; //+20
    height: 32px;
    // margin: 38px 0 0 40px;
    box-sizing: border-box;
    background: url("@/assets/temimg5/piebg3.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: calc(50% - 16px);
    top: calc(50% - 16px);
    z-index: 15;
}

.cmain {
    position: relative;
    width: 100%;
    height: 100%;
}
</style>